/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { FiltersState } from '../../FiltersContext';

export function convertBookingTypeFilters({
    params,
    filters,
}: {
    params: URLSearchParams;
    filters: FiltersState;
}): void {
    if (filters.bookingType) {
        if (filters.bookingType === 'nonReservable') {
            params.append('fg', 'poi');
            params.append('fg', 'recarea');
        } else if (filters.bookingType === 'permitsAndPasses') {
            params.append('fg', 'activitypass');
            params.append('fg', 'permits');
            params.append('fg', 'treepermits');
        } else if (filters.bookingType === 'venuesAndDayUse') {
            params.append('fg', 'venues');
            params.append('fg', 'dayuse');
        } else {
            // lower case because FE uses camel to avoid spelling issues
            params.append('fg', filters.bookingType.toLowerCase());
        }
    }
}

// cSpell:ignore recarea, activitypass, dayuse, treepermits
